import constants from '../../../core/constants';
function getTrafficModelId(json) {
    return json.viewpResp.trafficState['@trafficModelId'] || constants.VIEWPORT_DEFAULT_VALUE;
}

export default (json) => {
    return Object.assign(json, {
        getTrafficModelId: () => getTrafficModelId(json)
    });
};



// WEBPACK FOOTER //
// ./services/model/traffic/incidentViewport.js